import styled from 'styled-components';
import Zoom from 'react-reveal'
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import web1 from '../images/mentor/mentor1.png'
import web2 from '../images/mentor/mentor2.png'
import web3 from '../images/mentor/mentor3.png'
import web4 from '../images/mentor/mentor4.png'
import web5 from '../images/mentor/mentor5.png'
import web6 from '../images/mentor/mentor6.png'
function MentorCard() {
    
    const photo = 'https://imagesvc.meredithcorp.io/v3/mm/image?url=https%3A%2F%2Fstatic.onecms.io%2Fwp-content%2Fuploads%2Fsites%2F6%2F2012%2F09%2Fstyle-suits-gabriel-macht.jpg'
  return (
      <>
      <div className="container text-center">

                <Zoom>

                <h2>Find A Mentor, Get Your Brainstormed!
                    <p className=' subtitle m-auto w-75'><b>“ A mentor is someone who allows you to see the HOPE inside yourself”- Oprah Winfrey</b></p>
                </h2>
                </Zoom>
      </div>
    <Container className='container'>
        <div className='mentor-card'>
            <div className="details-container text-center p-2">

            <p className='h2'>Lorem Ipsum</p>
            <p>Lorem Ipsum is simply dummy text </p>
            <button>

            <LinkedInIcon/> Linkedin
            </button>
            </div>
            <img src={photo} alt="" />

            
        </div>
        <div className='mentor-card'>
            <div className="details-container text-center p-2">

            <p className='h2'>Lorem Ipsum</p>
            <p>Lorem Ipsum is simply dummy text </p>
            <button>

            <LinkedInIcon/> Linkedin
            </button>
            </div>
            <img src={photo} alt="" />

            
        </div>
        <div className='mentor-card'>
            <div className="details-container text-center p-2">

            <p className='h2'>Lorem Ipsum</p>
            <p>Lorem Ipsum is simply dummy text </p>
            <button>

            <LinkedInIcon/> Linkedin
            </button>
            </div>
            <img src={photo} alt="" />

            
        </div>
        <div className='mentor-card'>
            <div className="details-container text-center p-2">

            <p className='h2'>Lorem Ipsum</p>
            <p>Lorem Ipsum is simply dummy text </p>
            <button>

            <LinkedInIcon/> Linkedin
            </button>
            </div>
            <img src={photo} alt="" />

            
        </div>
        <div className='mentor-card'>
            <div className="details-container text-center p-2">

            <p className='h2'>Lorem Ipsum</p>
            <p>Lorem Ipsum is simply dummy text </p>
            <button>

            <LinkedInIcon/> Linkedin
            </button>
            </div>
            <img src={photo} alt="" />

            
        </div>
        
        
    </Container>
      </>
  )
}

export default MentorCard
const Container = styled.div` 

display:grid;
grid-gap:5px;
grid-template-columns: repeat(auto-fit, minmax(250px,1fr));
/* grid-template-rows:repeat(auto-fit, minmax(350px,1fr)) ; */
.mentor-card{
    position:relative ;
    background-image:linear-gradient(to bottom,white, rgb(0,0,0,.8)) ;
    height:400px ;
}
img{
    width:100% ;
    height:100% ;
    object-fit:cover ;
    /* border-radius:10px ; */

}
.details-container{
    position:absolute ;
    width:100% ;
    bottom:0 ;
}
.details-container p{
    color:white;
}
.details-container button{
    background-color:#fa7525 ;
    padding:10px 20px 10px 20px;
    border-radius:5px ;
    color:white ;
    border:none ;
    &:hover{
        background-color:#0A66C2 ;
        color:white;
    }
}
`